export const SIZES = {
  l: "l",
  m: "m",
  s: "s",
};
